import { AllVisitsPageNS } from '@/pages/AllVisitsPage/AllVisitsPage.types';
import { VisitRequestWorkflowStep } from '@/types/graphql';
import { Objects } from '@/utils/objects';

// const NEEDS_ATTENTION_SECONDARY_FILTERS = [
//     ['Overdue', true],
//     ['Missed', true],
//     ['Compliance', true],
//     ['Frequency Fulfillment', true],
//     ['Syncing', true],
//     ['Other', true],
// ] as const;

// export const NEEDS_ATTENTION_TABS = new Set<AllVisitsPageNS.SecondaryTabConfigSet>([]);

const NEEDS_ASSIGNMENT_SECONDARY_FILTERS = [
    [VisitRequestWorkflowStep.NEEDS_SERVICES, true],
    [VisitRequestWorkflowStep.NEEDS_CLINICIAN, true],
    [VisitRequestWorkflowStep.NEEDS_TENTATIVE_DATE, true],
    [VisitRequestWorkflowStep.READY_FOR_PROMOTION, true],
] as const;

export const NEEDS_ASSIGNMENT_TABS = new Set<AllVisitsPageNS.SecondaryTabConfigSet>(
    NEEDS_ASSIGNMENT_SECONDARY_FILTERS,
);

export const SECONDARY_TABS: Partial<
    Record<AllVisitsPageNS.PrimaryTab, Set<AllVisitsPageNS.SecondaryTabConfigSet>>
> = {
    // NEEDS_ATTENTION: NEEDS_ATTENTION_TABS,
    // NEEDS_ASSIGNMENT: NEEDS_ASSIGNMENT_TABS,
};

export const TAB_CONFIGS: AllVisitsPageNS.TabConfig[] = Objects.entries(
    AllVisitsPageNS.PRIMARY_TABS,
).map(([tab, label]) => ({
    tab,
    label: label,
    lowerTabs: SECONDARY_TABS[tab] ?? null,
}));

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DEFAULT_TAB = TAB_CONFIGS.find(
    (tab) => tab.tab === VisitRequestWorkflowStep.NEEDS_SERVICES,
)!;
